import { createTheme } from '@mui/material/styles';
import { baseTheme } from './base';
import { getComponents } from './components';
import { darkPalette } from './palette/darkPalette';
import { darkShadows } from './shadows';
import type { Theme } from '@mui/material/styles';

/**
 * Dark theme - the original default theme
 */
export const createDarkTheme = (): Theme => {
  const theme = createTheme({
    ...baseTheme,
    palette: darkPalette,
    shadows: darkShadows,
  });

  return createTheme(theme, {
    components: getComponents(theme),
  });
};
